import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=1b16ac6a&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"
import style0 from "./Files.vue?vue&type=style&index=0&id=1b16ac6a&prod&lang=scss&"
import style1 from "./Files.vue?vue&type=style&index=1&id=1b16ac6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16ac6a",
  null
  
)

export default component.exports